/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterCategory_filters$ref: FragmentReference;
export type SbRespRefineMenuFilterCategory_filters = $ReadOnlyArray<{|
  +name: ?string,
  +values: ?$ReadOnlyArray<?{|
    +count: ?number,
    +urlLabel: ?string,
    +displayName: ?string,
    +link: ?string,
  |}>,
  +$refType: SbRespRefineMenuFilterCategory_filters$ref,
|}>;
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterCategory_filters",
  "type": "SearchBrowseFilter",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "values",
      "storageKey": "values(limit:15)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 15,
          "type": "Int"
        }
      ],
      "concreteType": "SearchBrowseFilterValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "count",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "link",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '712e8a72ecfd1a9e076c8dafc039671c';
module.exports = node;
